import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import makeStyles from "@material-ui/core/styles/makeStyles";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import HubbleTable from "./HubbleTable";
import HubbleRequests from "services/hubble";
import CmtSearch from "@coremat/CmtSearch";
import { Box, Button, Typography } from "@material-ui/core";
import { Assessment } from "@material-ui/icons";
import HubbleReportDialog from "./HubbleReportDialog";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  searchBoxContainer: {
    display: "flex",
    alignItems: "center",
  },
  actionsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 20px",
  },
}));

const HubbleContainer = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { hubbleTotalDocs } = useSelector(({ hubble }) => hubble);
  const [openReportDialog, setOpenReportDialog] = useState(false);

  useEffect(() => {
    dispatch(HubbleRequests.getHubbleList(1));
  }, []);

  return (
    <>
      <CmtCard className={classes.cardRoot}>
        <CmtCardContent className={classes.cardContentRoot}>
          <Box className={classes.actionsContainer}>
            <Box className={classes.searchBoxContainer}>
              <CmtSearch
                border={false}
                onlyIcon={false}
                iconPosition="left"
                align="left"
                placeholder="جست و جو"
                value={""}
                onChange={(e) => console.log(e.target.value)}
              />
              <Typography>تعداد {hubbleTotalDocs} نتیجه یافت شد.</Typography>
            </Box>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<Assessment />}
              onClick={() => setOpenReportDialog(true)}
              style={{ marginRight: 14 }}
            >
              دریافت گزارش
            </Button>
          </Box>
          <HubbleTable />
        </CmtCardContent>
      </CmtCard>
      <HubbleReportDialog
        open={openReportDialog}
        handleClose={() => setOpenReportDialog(false)}
      />
    </>
  );
};

export default HubbleContainer;
